import React from 'react';
import ReactPaginate from 'react-paginate';
import css from './Pagination.css';
import { func, number } from 'prop-types';
import IconArrowHead from '../IconArrowHead/IconArrowHead';
import classNames from 'classnames';

const Pagination = props => {
  const { pageCount, marginPagesDisplayed, pageRangeDisplayed, onPageChange, forcePage, ...rest } = props;

  const rootClassName = classNames(props.rootClassName, css.root);
  const containerClassName = props.containerClassName || css.paginationContainer;
  const subContainerClassName = props.subClassName || css.paginationPages;
  const activeClassName = props.activePageClassName || css.currentPage;
  const pageLinkClassName = props.pageClassName || css.toPageLink;
  const pageClassName = props.pageClassName || css.toPageListItem;

  const previousArrow = <IconArrowHead direction="left" size="big" rootClassName={css.arrowIcon} />;
  const nextArrow = <IconArrowHead direction="right" size="big" rootClassName={css.arrowIcon} />;

  const paginationProps = {
    pageCount,
    containerClassName,
    subContainerClassName,
    activeClassName,
    onPageChange,
    nextLabel: nextArrow,
    previousLabel: previousArrow,
    nextClassName: css.next,
    previousClassName: css.prev,
    pageLinkClassName,
    pageClassName,
    breakClassName: pageClassName,
    breakLinkClassName: pageLinkClassName,
    marginPagesDisplayed,
    pageRangeDisplayed,
    forcePage
  };

  return (
    <div className={rootClassName}>
      <ReactPaginate {...paginationProps}/>
    </div>
  );
};

Pagination.defaultProps = {
  pageCount: 1,
  // number of neighbour page indices to display
  pageRangeDisplayed: 2,
  // number of start/end pages to display
  marginPagesDisplayed: 1,
};

Pagination.propTypes = {
  pageCount: number.isRequired,
  pageRangeDisplayed: number.isRequired,
  onPageChange: func.isRequired,
};

export default Pagination;
